import {View} from 'react-native';
import React, {useEffect, useRef} from 'react';
import {useAppSelector} from '../../store/hooks';
import {selectQuestions} from '../../store/xueke';
import {
  WebviewCustomerMemo,
  WebviewCustomerRef,
} from '../../components/WebviewCustomer';
import {AIWebviewURL} from '../../env/webviewUrl';
import {createStyles} from '../../utils/createStyles';
import {middlewareType} from '../../utils/webviewJSBridge';
import {useNavigation} from '@react-navigation/native';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';

const styles = createStyles({
  workBookParseBox: {
    flex: 1,
    height: '100%',
    backgroundColor: '#fff',
    // paddingRight: '1.15rem',
    // paddingVertical: '1.2rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  workBookParseBoxWeb: {
    flex: 1,
    height: '100%',
    borderRadius: '1rem',
    // padding: '1.5rem',
  },
  workBookParseBoxBtn: {
    marginLeft: '1.3rem',
    width: '7.25rem',
    height: '23rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  workBookParseBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  workBookParseBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  workBookParseBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },
});
const WorkBookParse = (props: {route: {params: any}}) => {
  const params = props.route.params;
  console.log('params', params);
  const navigation = useNavigation();
  const questions = useAppSelector<any>(selectQuestions);
  const webviewRef = useRef<WebviewCustomerRef>(null);
  const url = `${AIWebviewURL}/XKW/parse`;
  useEffect(() => {
    showGlobalLoading({text: '加载中...'});
  }, []);
  const handleWebViewLoadEnd = () => {
    hideGlobalLoading();
    webviewRef.current?.sendMessage({
      eventName: 'onQuestions',
      data: {
        questions: questions.data,
        id: params?.id || 0,
        three: params?.three || false,
        sub_title:
          '学校：________ 姓名：________ 班级：________ 考号：________',
        title: `同步练习测试 ${new Date().toLocaleDateString()}`,
      },
    });
  };
  const webEventHandle: middlewareType = (eventName, data, res) => {
    switch (eventName) {
      case 'goReport': {
        console.log('WebMounted');
        // @ts-ignore
        navigation.navigate('AnswerReport', {
          id: data.id,
        });
        break;
      }
        case 'WebMounted': {
            console.log('WebMounted');
            handleWebViewLoadEnd();
            break;
        }
    }
  };
  return (
    <View style={styles.workBookParseBox}>
      <View style={styles.workBookParseBoxWeb}>
        <WebviewCustomerMemo
          ref={webviewRef}
          eventHandle={webEventHandle}
          url={url}
          onLoadEnd={handleWebViewLoadEnd}
        />
      </View>
    </View>
  );
};

export default WorkBookParse;
